import { render, staticRenderFns } from "./c_foot.vue?vue&type=template&id=9e44e30c&scoped=true&"
import script from "./c_foot.vue?vue&type=script&lang=js&"
export * from "./c_foot.vue?vue&type=script&lang=js&"
import style0 from "./c_foot.vue?vue&type=style&index=0&id=9e44e30c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e44e30c",
  null
  
)

export default component.exports